import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const NotificationsLazy = loadable(() => import(/* webpackChunkName: "Notifications" */ './NotificationsSuspense'));

export const NotificationsAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <NotificationsLazy />
    </DelayedSuspense>
);
